export default {
  title: 'Studio (V2)',
  description: 'Rakenna ja hallitse ravintolan verkkosivustoa uudella Website Studiolla.',
  retry: 'Yritä uudelleen',
  deleted: 'Projekti poistettu.',
  errors: {
    load: 'Studio (V2) -projektia ei voitu ladata.',
    create: 'Projektia ei voitu luoda. Yritä uudelleen.',
    delete: 'Projektia ei voitu poistaa. Yritä uudelleen.',
  },
  EmptyState: {
    title: 'Ei vielä Studio (V2) -projektia',
    description: 'Luo projekti rakentaaksesi verkkosivuston uudella Website Studiolla. Studio (V1) säilyy ennallaan.',
    description_no_access: 'Onboarding-manageri voi luoda projektin tälle brändille.',
    create: 'Luo projekti',
  },
  ProjectCard: {
    unnamed: 'Nimeämätön projekti',
    edit: 'Muokkaa Studiossa',
    delete: 'Poista',
    open: 'Avaa',
    no_domain: 'Ei vielä verkkotunnusta',
    fields: {
      uuid: 'UUID',
      domain: 'Verkkotunnus',
      websites: 'Verkkosivustot',
    },
    delete_confirm: {
      title: 'Poistetaanko tämä projekti?',
      description: 'Tämä poistaa Studio (V2) -projektin ja sen verkkosivustot. Voit luoda uuden myöhemmin.',
      ok: 'Poista',
      cancel: 'Peruuta',
    },
  },
};
